export const NavbarData = [
  {
    title: "ABOUT US",
    isMenu: true,
    menu: [
      {
        title: "A Glance",
        link: "/about-us/a-glance",
      },
      {
        title: "Corporate Strategy",
        link: "/about-us/corporate-strategy",
      },
      {
        title: "Chairman's Message",
        link: "/about-us/chairmans-message",
      },
      {
        title: "Sustained Development",
        link: "/about-us/sustained-development",
      },
    ],
  },
  {
    title: "SOLUTIONS",
    isMenu: true,
    menu: [
      {
        title: "Piping Technologies",
        link: "/solutions/piping-technologies",
      },
      {
        title: "Piping Systems Usage",
        link: "/solutions/piping-systems-usage",
      },
      {
        title: "Ultimate Solutions",
        link: "/solutions/ultimate-solutions",
      },
      {
        title: "RAKtherm Quality",
        link: "/solutions/raktherm-quality",
      },
    ],
  },
  {
    title: "SERVICES & SUPPORT",
    isMenu: true,
    menu: [
      {
        title: "Catalogues & Downloads",
        link: "/services-and-support/catalogues-and-downloads",
      },
      {
        title: "Certifications",
        link: "/services-and-support/certifications",
      },
      {
        title: "Guidelines",
        isSubMenu: true,
        link: "/services-and-support/guidelines",
        subMenu: [
          {
            title: "Welding",
            link: "",
          },
          {
            title: "Linear Expansion",
            link: "",
          },
          {
            title: "RAKtherm Pressure Test",
            link: "",
          },
          {
            title: "Standards & Regulations",
            link: "",
          },
          {
            title: "Transport & Storage",
            link: "",
          },
        ],
      },
    ],
  },
  //   {
  //     title: "BLOGS",
  //     isMenu: false,
  //     menu: [

  //       ],
  //   },
  //   {
  //       title: "RAKTHERM ACADEMY",
  //       isMenu: false,
  //       link: "raktherm-academy",
  //       menu: [

  //         ],
  //     },
];

export const Navdata2 = [
  {
    title: "RAKTHERM WORLDWIDE",
    isMenu: true,
    menu: [
      {
        title: "Global Networks",
        link: "/raktherm-worldwide/global-networks",
      },
      {
        title: "Mega Projects",
        link: "/raktherm-worldwide/mega-projects",
      },
      {
        title: "Become Stockist",
        link: "/raktherm-worldwide/become-stockist",
      },
      {
        title: "Join My RAKtherm",
        link: "/raktherm-worldwide/join-my-raktherm",
      },
    ],
  },
  {
    title: "CONTACTS",
    isMenu: true,
    menu: [
      {
        title: "Meet Our Team",
        link: "/contacts/meet-our-team",
      },
      {
        title: "Join Our Team",
        link: "/contacts/join-our-team",
      },
    ],
  },
  {
    title: "EN",
    isMenu: true,
    menu: [
      {
        title: "English",
        link: "",
      },
      {
        title: "Arabic",
        link: "",
      },
    ],
  },
];
